<template>
    <span v-html="parse()"></span>
</template>

<script>

import ValueChecker from "@/services/ValueChecker";

export default
{
    components: {},
    props: {
        column: {
            type: Object,
        },
        config: {
            type: Object,
        },
        row: {
            type: Object,
        },
    },
    data() {
        return {

        };
    },
    computed: {
    },
    mounted() {
    },
    methods: {
        parse() {
            return this.parseTemplate();
        },
        mapRow(value) {
            let rowValue = this.row[value];

            if (ValueChecker.isUndefinedOrNull(rowValue)) {
                return '';
            }

            return rowValue;
        },
        parseTemplate() {
            //Check can override template from data
            let templateConfigFromStore = this.mapRow(this.config['templateConfigIndex']);
            let template = templateConfigFromStore || this.config.template;
            let params = template.match(/(?<={).*?(?=})/g);
            params.forEach(v => {
                let index = this.config[v];
                template = template.replace('{' + v + '}', this.mapRow(index));
            });

            return template;
        },
    }
}
</script>

<style lang="sass">
</style>



// WEBPACK FOOTER //
// TemplateColumnComponent.vue?65959df6